const e=async(e,t,n,r)=>{let{data:i}=await e.post(`/webhooks/${t}/${n}`,r);return i};export{e as createWebhook};
//# sourceMappingURL=create-webhook.mjs.map